module.exports = {"name":"bitdashvr","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.0","built":"2017-11-20","repo":"https://bitbucket.org/npaw/bitdashvr-adapter-js","libVersion":"6.1.4","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getBitrate","getRendition","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 26
// module chunks = 0